<template>
  <div :class="$style.container">
    <van-tabs :class="$style.tabs" v-model="active" color="#ffa61b" name="retourRecord">
      <van-tab title="我的红包">
        <div class="record">
          <div class="empty" v-if="!rewardList.length">
            <img :src="`${rootCDNUrl}/empty.png`" alt="" />
            <p>暂无数据，快去下载游戏领取吧~</p>
          </div>
          <template v-else>
            <div class="tip">
              <div
                class="tip_icon bg_contain mr_4"
                :style="{ backgroundImage: `url(${rootCDNUrl}/info.png)` }"
              />
              <div class="tip_main fs_13">代金券使用方法：游戏内支付自动使用</div>
            </div>
            <div class="list">
              <div
                class="item shadow"
                v-for="(reward, index) in rewardList"
                :key="`${reward.receive_time}-${index}`"
                :class="{ it_disalbed: [0, 2].includes(reward.status) }"
              >
                <div class="it_left flex_a_c d_flex_col">
                  <div class="relative flex_a_b">
                    <!-- 满减 -->
                    <template v-if="reward.type === 1">
                      <div class="it_symbol">￥</div>
                      <div class="it_value">{{ reward.off_money }}</div>
                    </template>
                    <!-- 折扣 -->
                    <template v-if="reward.type === 2">
                      <div class="it_value" :style="{ marginLeft: '-18px' }">
                        {{ reward.percent * 10 }}
                      </div>
                      <div class="it_discount">折</div>
                    </template>
                  </div>
                  <!-- 满减 -->
                  <template v-if="reward.type === 1">
                    <div :class="{ hidden: !reward.condition_money }" class="it_useage fs_13 mt_8">
                      {{ `满${reward.condition_money}可用` }}
                    </div>
                  </template>
                </div>
                <div class="it_rip"></div>
                <div class="it_right">
                  <div class="it_title mb_8 bold">{{ reward.act_voucher_name }}</div>
                  <div class="it_desc mb_8 fs_13">适用游戏: {{ reward.expo_name }}</div>
                  <div class="it_expire color_grey">
                    {{ slice016(reward.receive_time) }}至{{ slice016(reward.invalid_time) }}
                  </div>
                </div>
                <img
                  v-if="reward.status === 2"
                  :src="`${rootCDNUrl}/used.png`"
                  class="it_has_expired"
                />
                <img
                  v-if="reward.status === 0"
                  :src="`${rootCDNUrl}/expired.png`"
                  class="it_has_expired"
                />
              </div>
            </div>
          </template>
        </div>
      </van-tab>
      <van-tab title="领取记录">
        <div class="record_wrap">
          <div class="empty" v-if="!recordList.length">
            <img :src="`${rootCDNUrl}/empty.png`" alt="" />
            <p>暂无数据，快去下载游戏领取吧~</p>
          </div>
          <template v-else>
            <div class="record_item record_title">
              <div class="record_td bold record_left">{{ columns[0] }}</div>
              <div class="record_td bold record_mid">{{ columns[1] }}</div>
              <div class="record_td bold record_right">{{ columns[2] }}</div>
            </div>
            <div class="record_list">
              <div
                v-for="(record, index) in recordList"
                :key="`${record.receive_time}-${index}`"
                class="record_item"
              >
                <div class="record_td record_left">{{ record.receive_time }}</div>
                <div class="record_td record_mid">{{ recordDetail(record) }}</div>
                <div class="record_td record_right" v-if="record.type === 'role_gift'">
                  <div>{{ record.name }}</div>
                  <span
                    v-if="record.role_gift_code"
                    v-clipboard="record.role_gift_code"
                    class="fs_10 text_nowrap"
                    style="color: #2b35ff"
                  >
                    <i class="iconfont yw-copy fs_10"></i>复制礼包码
                  </span>
                  <span class="fs_10" style="color: #ff3000" v-else> 领取失败 </span>
                </div>
                <div class="record_td record_right" v-if="record.type === 'voucher_receive'">
                  {{ record.name }}
                </div>
                <div class="record_td record_right" v-if="record.type === 'condition_receive'">
                  -
                </div>
              </div>
            </div>
          </template>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { Tab, Tabs, Popup, Empty } from 'vant';
import { retourGameRecordList, retourGameVoucherList } from '@/api/activity';

export default {
  components: {
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Popup.name]: Popup,
    [Empty.name]: Empty,
  },
  props: {
    expoId: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // 活动 id
    actId() {
      return this.$route.query.id;
    },
  },
  data() {
    return {
      active: 0,
      rootCDNUrl: '//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/voucherAct',
      columns: ['领取时间', '抽奖/兑换明细', '奖励明细'], // 表格列标题
      rewardList: [], // 红包列表
      recordList: [], // 领取记录列表
    };
  },
  watch: {
    visible: {
      handler(newValue) {
        if (newValue) {
          this.initData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    slice016(str) {
      return typeof str.slice === 'function' ? str.slice(0, 16) : str;
    },
    // 初始化数据
    initData() {
      console.log('get record list');
      this.getUserGetRecord();
      this.getUserRedBagRecord();
    },
    // 领取记录 - 抽奖/兑换明细
    recordDetail(item) {
      if (!item) return '-';

      switch (item.type) {
        case 'role_gift':
          return `-`;
        case 'condition_receive':
          return `次数${item.count > 0 ? '+' : '-'}${item.count}`;
        case 'voucher_receive':
          return '次数' + item.count;
        default:
          return '-';
      }
    },
    // 获取用户领取记录
    async getUserGetRecord() {
      if (!this.expoId || !this.actId) return;

      const res = await retourGameRecordList({ id: this.actId, expo_id: this.expoId });

      if (!res.data || !res.data.receive_record_list) return;

      this.recordList = res.data.receive_record_list || [];
    },
    // 获取用户红包记录
    async getUserRedBagRecord() {
      if (!this.expoId || !this.actId) return;

      const res = await retourGameVoucherList({ id: this.actId, expo_id: this.expoId });

      if (!res.data) return;

      this.rewardList = res.data || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.record_wrap {
  padding-top: 10px;
  padding-bottom: 40px;
}
.record_list {
  padding: 6px 0;
  color: #616161;
}
.record_item {
  display: flex;
  align-items: center;
}
.record_title {
  padding-bottom: 6px;
  border-bottom: 1px #eee solid;
}
.record_td {
  width: 33%;
  text-align: center;
}
.record-title {
  padding-bottom: 12px;
  border-bottom: 1px solid #b7b7b7;
}
.record_item + .record_item {
  margin-top: 16px;
}
.fs_10 {
  font-size: 10px;
}

.record {
  padding-top: 10px;
  padding-bottom: 40px;
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;
  height: 100vh;
  padding-top: 130px;
  background-color: #f8f8f8;
  color: #919191;
  img {
    width: 100px;
    margin-bottom: 40px;
  }
}
.tip {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  padding: 6px 24px;
  background: #ffcc82;
  color: #ff601a;
  margin-bottom: 8px;
  .tip_icon {
    width: 14px;
    height: 14px;
  }
}

.fs_13 {
  font-size: 13px;
}
.list {
  width: 100%;
  padding: 6px 16px;
}
.item {
  position: relative;
  width: 100%;
  display: flex;
  padding: 8px 12px;
  color: #ff590f;
  background-color: #fae7d6;
  border-radius: 8px;
  margin-bottom: 8px;
  .it_left {
    width: 84px;
    justify-content: center;
  }
  .it_right {
    flex: 1;
    .it_title {
      font-size: 19px;
    }
    .it_expire {
      font-size: 11px;
    }
  }
  .it_rip {
    position: relative;
    border-left: 1px dashed #bbb;
    margin-right: 16px;
    &:before,
    &:after {
      content: '';
      position: absolute;
      width: 20px;
      height: 10px;
      left: 0px;
      background-color: #fff;
      pointer-events: none;
    }
    &:before {
      top: 0px;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      transform: translate(-50%, calc(-50% - 5px));
    }
    &:after {
      bottom: 0px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
      transform: translate(-50%, calc(50% + 5px));
    }
  }
  .it_symbol {
    position: absolute;
    bottom: 2px;
    left: -18px;
    font-size: 18px;
  }
  .it_value {
    font-size: 32px;
    font-weight: bold;
  }
  .it_discount {
    position: absolute;
    bottom: 4px;
    right: -20px;
    font-size: 16px;
  }
  .it_has_expired {
    position: absolute;
    right: 4px;
    top: 4px;
    width: 75px;
  }
}
.item + .item {
  margin-top: 5px;
}
.it_disalbed {
  background-color: #e6e7ec;
  color: #99999a;
}
.shadow {
  box-shadow: 1px 1px 0px 0px rgba(165, 165, 165, 0.6);
}
.hidden {
  visibility: none;
}
</style>
<style lang="scss" module>
.container {
  width: 100vw;
  min-height: 100vh;
}
</style>
